import clsx from 'clsx'
import React from 'react'
import { NavLink } from 'react-router-dom'

interface Tab {
  label: string
  to: string
}

const tabs: Tab[] = [{ label: 'All Assets', to: '/wallet/all' }]

interface AssetTabsProps {
  className?: string
}

const AssetTabs: React.FC<AssetTabsProps> = ({ className }) => {
  return (
    <div className={clsx('border-b border-main', className)}>
      <nav className='flex gap-2'>
        {tabs.map(tab => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              clsx(
                'py-2.5 font-medium text-center', // Common
                'text-label1 px-2', // Mobile classes
                'sm:text-label2 sm:px-4', // Desktop classes
                {
                  'text-main-accent border-b-2': isActive,
                  'text-main-muted hover:text-main-accent': !isActive,
                }
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </div>
  )
}

export default AssetTabs
